import { ANIMALES_ACCOUNTING_ENTRY_CATEGORY } from './../../../../utils/consts';
import { UnifiedCashflowInputComponentComponent } from 'src/app/modules/cashflow/unified-cashflow-input-component/unified-cashflow-input-component.component';
import { RoutingConfig } from 'src/app/utils/routing-config';
import { ToastUtils } from 'src/app/utils/toast_builder';
import { ANIMAL_IDS } from '../../../../utils/consts';
import { Component, Input, OnInit } from '@angular/core';
import { IonNav, ModalController, PopoverController } from '@ionic/angular';
import { dev } from '../../../../config/offlines_keys.json';
import { Preferences } from '@capacitor/preferences';
import { AnimalesFormComponent } from '../animals-form/animals-form.component';
import { UpdateAnimalPropretyComponent } from '../update-animal-proprety/update-animal-proprety.component';
import routes from '../../../../config/routing.json';
import { Router } from '@angular/router';
import { GoodsAPI } from 'src/app/apis/goods.service';
import { ProductionSalesOtherComponent } from 'src/app/modules/home/cashflow/production-sales-other/production-sales-other.component';
import { showConfirmModal } from 'src/app/utils/pop_over_maker';
import { UserInfo } from 'src/app/apis/users-info.service';
import { ProductionsPerfarm } from 'src/app/models/farm/production_per_farm';
import { ProductionAPI } from 'src/app/apis/FarmAPI/productions.service';
import { Good } from 'src/app/models/good.model';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { deleteAnimalGood, deleteSelectedAnimal, loadAnimal, loadSelectedAnimal } from 'src/app/utils/states-management/actions/animals.action';
import { selectedAnimalProducts } from 'src/app/utils/states-management/reducers/animals.reducer';
import Owner from 'src/app/models/owner.model';
import { cloneDeep } from 'lodash';
import { connectionStatus } from 'src/app/utils/states-management/reducers/offline.reducer';

@Component({
  selector: 'app-animals',
  templateUrl: './animals.component.html',
  styleUrls: ['./animals.component.scss'],
})
export class AnimalesComponent implements OnInit {
  owner;
  productList: Array<ProductionsPerfarm>;
  lang;
  isDashboardView;
  @Input() nav: IonNav;
  @Input() rootStack;
  is_loading = true;
  update_at;
  base_url = 'assets';

  constructor(
    private modalController: ModalController,
    private router: Router,
    private popoverController: PopoverController,
    private goodsAPi: GoodsAPI,
    private userInfo: UserInfo,
    public translateService: TranslateService,
    private productionAPI: ProductionAPI,
    private toastUtils: ToastUtils,
    private routingConfig: RoutingConfig,
    private store: Store<{
      animals: any;
      owner: Owner
    }>
  ) { }
  title = '';
  async ngOnInit() {
    this.isDashboardView = this.router.url.includes(routes.dashboard.home)
    Preferences.get({ key: dev.LANGAGE_KEY }).then((value) => {
      this.lang = value.value;
    });
    this.store.select(connectionStatus).subscribe((val: boolean) => {
      this.isOnline = val;
    });

    this.store.select('owner').subscribe(async (value: any) => {
      let owner = cloneDeep(value);
      if (JSON.parse(owner.profile_info)?.role == 'farmer') {
        this.title = 'titles.animals_production_selector'
      } else {
        this.title = 'titles.animals_production_selector_shop'
      }
    });

    this.store.dispatch(loadAnimal());
    this.store.dispatch(loadSelectedAnimal());

    this.fetchAnimals()
  }

  getLastUpdate(products) {
    if (products.length > 0) {
      var maxDate = new Date(
        Math.max(
          ...products.map((element) => {
            return new Date(element.created_at);
          })
        )
      );
      this.update_at = maxDate;
    }
  }
  isProcessing: boolean = false;

  async add() {
    this.isProcessing = true;

    let componentProps = {
      modalController: this.modalController,
      lists: this.productList,
    };
    let modal = await this.toastUtils.modalBuilder(
      AnimalesFormComponent,
      componentProps,
      ['my-custom-modal-css', 'modal-wrapper']
    );

    await modal.onWillDismiss();
    this.isProcessing = false;

  }

  async deletePressed(object, animal) {
    let farmProduction: ProductionsPerfarm = animal;
    let goodTobeDeleted: Good = object.item;

    this.deleteEntry(farmProduction, goodTobeDeleted);
  }

  fetchAnimals() {
    this.is_loading = true;
    this.store.select(selectedAnimalProducts).subscribe(animals => {
      console.log(animals)
      this.productList = animals;
      this.getLastUpdate(this.productList);
      this.is_loading = false;
    })

  }

  async updateGood(good) {
    let componentProps = {
      modalController: this.modalController,
      owner: this.owner,
      entry: good?.entry,
    };
    let modal = await this.toastUtils.modalBuilder(
      UpdateAnimalPropretyComponent,
      componentProps,
      ['my-custom-modal-css', 'modal-wrapper'],
      true,
      '2'
    );

    await modal.onWillDismiss();
    this.fetchAnimals();
  }

  async getCashflowRequestConfirmation(msg): Promise<Boolean> {
    const modal = await showConfirmModal(
      this.popoverController,
      msg,
      null,
      this.lang === 'es' ? 'Sí' : 'Yes',
      'No'
    );

    const { data } = await modal.onWillDismiss();
    return data?.confirmed;
  }

  async showOtherInputComponent(products: ProductionsPerfarm) {
    const cashFlowCategFiltred = JSON.parse(
      (
        await Preferences.get({
          key: dev.CASHFLOW_CATEGORIES,
        })
      ).value
    );

    let componentProps = {
      accountingEntryCategories: cashFlowCategFiltred.find(
        (value) => value.id === ANIMALES_ACCOUNTING_ENTRY_CATEGORY
      ),
    };
    let modal = await this.toastUtils.modalBuilder(
      UnifiedCashflowInputComponentComponent,
      componentProps,
      ['my-custom-modal-css', 'modal-wrapper'],
      true,
      '1'
    );

    await modal.onWillDismiss();
  }
  async requestUserToInsertCashflow(
    msg: string,
    farmProduction: ProductionsPerfarm
  ) {
    const modal = await showConfirmModal(
      this.popoverController,
      msg,
      null,
      await this.translateService.get('yes').toPromise(),
      await this.translateService.get('no').toPromise()
    );
    const { data } = await modal.onWillDismiss();
    if (data?.confirmed) {
      await this.showOtherInputComponent(farmProduction);
    }
    return data?.confirmed;
  }



  deleteEntry(farmProduction, goodTobeDeleted) {
    if (
      ANIMAL_IDS.includes(goodTobeDeleted.material_product_id) ||
      (farmProduction?.goods && farmProduction?.goods.length === 1)
    ) {
      this.deleteProduction(farmProduction);
    } else {
      this.deleteFromGoodsTable(goodTobeDeleted, farmProduction);
    }
  }
  isOnline: boolean = true

  async deleteProduction(productionDelete: any) {
    // Handle offline mode
    if (!this.isOnline) {
      this.store.dispatch(deleteSelectedAnimal({ product: productionDelete }));
      return;
    }

    try {
      // Get translations in parallel for better performance
      const [msg, confirmButton, cancelButton] = await Promise.all([
        this.translateService.instant('label.delete_animal'),
        this.translateService.instant('confirm'),
        this.translateService.instant('cancel')
      ]);

      // Show confirmation modal
      const modal = await showConfirmModal(
        this.popoverController,
        msg,
        null,
        confirmButton,
        cancelButton
      );

      // Wait for user response
      const { data } = await modal.onWillDismiss();

      // Delete animal if confirmed
      if (data?.confirmed) {
        this.store.dispatch(deleteSelectedAnimal({ product: productionDelete }));
      }
    } catch (error) {
      console.error('Error during animal deletion process:', error);
      // You could add error handling here, like showing a toast notification
    }
  }
  deleteFromGoodsTable(good: Good, productionDelete: any) {
    this.store.dispatch(deleteAnimalGood({ product: productionDelete, good: good }))
  }

  async redirect() {
    this.router.navigateByUrl(await this.routingConfig.getNextUrl());
  }

  async mreturn() {
    this.router.navigateByUrl(await this.routingConfig.getBackUrl());
  }

  detailsClicked(item) {
    this.nav.setRoot(ProductionSalesOtherComponent, {
      nav: this.nav,
      product: item,
    });
  }
}
